import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { db } from '../services/firebase';
import { collection, getCountFromServer, query, where } from 'firebase/firestore';
import { useSeller } from '../contexts/SellerContext';
import {
  ChevronRight,
} from 'lucide-react';
const MyCatalogue = () => {
  const nav = useNavigate();
  const { seller } = useSeller();
  const sellerId = seller?.sellerId;

  const [productCounts, setProductCounts] = useState({
    qcPending: 0,
    qcRejected: 0,
    readyStock: 0,
    orderServe: 0,
    outOfStock: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductCounts = async () => {
      try {
        if (!sellerId) {
          setLoading(false);
          return;
        }
        const productsRef = collection(db, 'products');
        const qPending = query(productsRef, where('sellerId', '==', sellerId), where('status', '==', 'pending'));
        const qRejected = query(productsRef, where('sellerId', '==', sellerId), where('status', '==', 'rejected'));
        const qApprovedReady = query(productsRef, where('sellerId', '==', sellerId), where('status', '==', 'approved'), where('serviceType', '==', 'ready'));
        const qApprovedOrder = query(productsRef, where('sellerId', '==', sellerId), where('status', '==', 'approved'), where('serviceType', '==', 'order'));
        const qApprovedOut = query(productsRef, where('sellerId', '==', sellerId), where('status', '==', 'approved'), where('serviceType', '==', 'out'));
        const [
          pendingSnap,
          rejectedSnap,
          readySnap,
          orderSnap,
          outSnap
        ] = await Promise.all([
          getCountFromServer(qPending),
          getCountFromServer(qRejected),
          getCountFromServer(qApprovedReady),
          getCountFromServer(qApprovedOrder),
          getCountFromServer(qApprovedOut)
        ]);

        setProductCounts({
          qcPending: pendingSnap.data().count,
          qcRejected: rejectedSnap.data().count,
          readyStock: readySnap.data().count,
          orderServe: orderSnap.data().count,
          outOfStock: outSnap.data().count
        });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching product counts:', error);
        setLoading(false);
      }
    };

    if (sellerId) {
      fetchProductCounts();
    }
  }, [sellerId]);



  const catalogueItems = [
    {
      id: 1,
      title: 'Add Products',
      path: '/UploadProduct',
      description: 'Create new listings',
      color: 'yellow',
      count: null,
      icon: '+'
    },
    {
      id: 2,
      title: 'QC Pending',
      description: 'Awaiting quality check',
      color: 'yellow',
      count: loading ? '...' : productCounts.qcPending,
      icon: <ChevronRight />,
      type: 'pending'
    },
    {
      id: 3,
      title: 'QC Rejected',
      description: 'Needs fixes & resubmission',
      color: 'red',
      count: loading ? '...' : productCounts.qcRejected,
      icon: <ChevronRight />,
      type: 'rejected'
    },
    {
      id: 4,
      title: 'Ready Stock Catalogue',
      description: 'Approved & in stock',
      color: 'purple',
      count: loading ? '...' : productCounts.readyStock,
      icon: <ChevronRight />,
      type: 'ready'
    },
    {
      id: 5,
      title: 'Order Serve Catalogue',
      description: 'Make-to-order items',
      color: 'light-blue',
      count: loading ? '...' : productCounts.orderServe,
      icon: <ChevronRight />,
      type: 'order'
    },
    {
      id: 6,
      title: 'Out of Stock Catalogue',
      description: 'Temporarily unavailable',
      color: 'green',
      count: loading ? '...' : productCounts.outOfStock,
      icon: <ChevronRight />,
      type: 'out'
    }
  ];

  const handleItemClick = (item) => {
    if (item.path) {
      nav(item.path);
    } else if (item.type) {
      // Navigate to the dynamic catalogue component with the type parameter
      nav(`/catalogue/${item.type}`);
    }
  };

  return (
    <>
      <Header title="My Catalogue" />
      <div className="workflow-container">
        <div className="workflow-steps">
          {catalogueItems.map((item) => (
            <div
              key={item.id}
              className={`step-card ${item.color}`}
              onClick={() => handleItemClick(item)}
            >
              {/* ✅ Main content wrapper */}
              <div className="readystep-content">
                {/* Step number */}
                <div className={`step-number ${item.color}`}>
                  {item.id}
                </div>

                {/* Details */}
                <div className="step-details">
                  <h3 className="workstep-title">{item.title}</h3>
                  <p className="step-subtitle">{item.description}</p>
                </div>

                <div className="step-count">
                  <span>{item.count}</span>
                  <span
                    className="arrow"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleItemClick(item);
                    }}
                  >
                    {item.icon}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MyCatalogue;